module.exports = "/_next/static/images/tournaments-9285e2a1d1473c06b17c842fd3e1a2c7.jpg";